import { ILabel } from "../models/label.model";

export function getLabel(
  labels: ILabel[] | undefined | null,
  labelName: string
): string {
  let matchingLabels = labels?.filter((l) => l.name === labelName)[0];
  return matchingLabels ? matchingLabels.text ?? "" : labelName;
}
